import { ElMessage } from "element-plus";
import { defineStore } from "pinia";
import { 
    getFlightPlanTableData, getFlightPlanDataById, addFlightPlanData, auditFlightPlan
} from "@/services";

const useFlightPlanStore = defineStore("flightPlan", {
    state: () => ({
        pageTitle: '',
        tableAllData: {},
        selectedTerminal: {
            startingTerminal: [],
            endTerminal: [],
            dockingTerminal: []
        },
        flyMachineSeOption: [],
        flyMachineSeMap: {},
        purposeMap: {},
    }),
    actions: {
        async getFlightPlanDataById(params) {
            let result = await getFlightPlanDataById(params);
            return result.data
        },
        
        async getFlightPlanTableData(params) {
            let result = await getFlightPlanTableData(params)
            this.tableAllData = result.data
        },
        async addFlightPlanData(params) {
            let  result = await addFlightPlanData(params)
            return result
        },
        async auditFlightPlan(params) {
            let result = await auditFlightPlan(params);
            return result
        },
        
    },
});

export default useFlightPlanStore;
